import { Component, input } from '@angular/core';
import type { ButtonActionType } from '../../../internal/interfaces';
import { OnyxIconComponent } from '../../icons/onyx-icon/onyx-icon.component';

@Component({
  selector: 'onyx-clear-button',
  imports: [OnyxIconComponent],
  templateUrl: './onyx-clear-button.component.html',
  styleUrl: './onyx-clear-button.component.scss',
})
export class OnyxClearButtonComponent {
  public readonly actionType = input<ButtonActionType>('button');
}
